export const SPONSORED_FEED_CONFIG = {
  firstInsertionAfterOrganicPosts: 4,
  subsequentOrganicIntervals: [6, 8],
} as const;

export const SPONSORED_VISIBILITY_CONFIG = {
  minimumViewTimeMs: 1_000,
  itemVisiblePercentThreshold: 50,
} as const;
